<script setup>
import { ref, defineEmits } from 'vue';
const props = defineProps({
    title: {
        type: String,
        default: 'Title'
    },
    gap: {
        type: Boolean,
        default: true
    }
})
const isOpen = ref( true );

</script>

<template>
    <div class="flex flex-col gap-3">
        <div class="flex items-center justify-between">
            <h3 class="font-bold text-base text-gray-700 tracking-wide border-l-4 pl-3 border-indigo-600">
                <slot name="title" v-if="$slots.title" />
                <span v-else>{{props.title}}</span>
            </h3>
            <div @click="isOpen = !isOpen" class="w-8 h-8 hover:bg-gray-100 transition cursor-pointer flex items-center justify-center rounded-sm">
                <svg :class="{ 'rotate-180' : isOpen }" xmlns="http://www.w3.org/2000/svg" class="fill-current w-5 transition duration-200" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                  </svg>
            </div>
        </div>
        <transition name="slide">
            <div v-if="isOpen" class="rounded-sm flex flex-col gap-5" :class="{
                'bg-slate-50 p-5' : props.gap,
            }" v-bind="$attrs">
<slot></slot>            </div>
        </transition>
    </div>
</template>